enum DemoAccountType {
  STUDENT = 'STUDENT',
  TEACHER = 'TEACHER',
  DISTRICTADMIN = 'DISTRICT ADMIN',
}

export default DemoAccountType;
